var bundleAPI;
var originalMiniCssF = __webpack_require__.miniCssF;
__webpack_require__.miniCssF = function(chunkId) {
  if (!bundleAPI) {
    bundleAPI = __webpack_require__(38778).rtlManager.registerBundle("kolibri.core.default_frontend");
  }
  return bundleAPI.miniCssF(originalMiniCssF(chunkId));
};